import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {Spinner} from "react-bootstrap";
import CheckboxColumn from "../../../../components/CheckboxColumn";
import UserActionButton from "./UserActionButton";

const UserTable = ({t, list }) => {

    const columns = [
        {
            Header: 'active',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return <CheckboxColumn dataValue={data.isEnabled} disabled={true}/>
            },
        },
        {
            Header: 'username',
            accessor: 'username',
        },
        {
            Header: 'firstName',
            accessor: 'firstName'
        },
        {
            Header: 'lastName',
            accessor: 'lastName'
        },
        {
            Header: 'email',
            accessor: 'email'
        },
        {
            Header: 'role',
            accessor: 'role.label'
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return <UserActionButton row={data} />
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h4>{t('users-no-content')}</h4>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                    getTrProps={(state, rowInfo, columns) => {
                        return {
                            style: {background: (rowInfo.original.isEnabled ? '#FFFFFF': 'antiquewhite')}
                        }
                    }}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )

};
export default withNamespaces()(UserTable);
